import { apiSlice } from "../../app/api/apiSlice";

export const applicationApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getBrokerList: builder.mutation({
			// query: (credentials) => ({
			// 	url: `/api/v1/admin/broker_search?organization=${credentials?.companyName}&email=${credentials?.email}`,
			// 	method: "GET",
			// }),
			query: (credentials) => {
				const organization = encodeURIComponent(credentials?.companyName ?? "");
				const email = encodeURIComponent(credentials?.email ?? "");
				return {
					url: `/api/v1/admin/broker_search?organization=${organization}&email=${email}`,
					method: "GET",
				};
			},
		}),
	}),
});

export const { useGetBrokerListMutation } = applicationApiSlice;
